import React from 'react';
import Card, { CardSection } from '@lightspeed/cirrus-card';
import Text from '@lightspeed/cirrus-text';

const NotFound = () => (
  <div className="react-page__listing" data-test="page-not-found">
    <Card>
      <CardSection>
        <Text body>Page not found</Text>
      </CardSection>
    </Card>
  </div>
);

export default NotFound;
